import importerStore from '@shared/importer/importer-store';
import { PropertySettingService } from '@modules/property-setting/property-setting-service';
import propertySettingImporterFields from '@modules/property-setting/property-setting-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PropertySettingService.import,
  propertySettingImporterFields,
  i18n('entities.propertySetting.importer.fileName'),
  i18n('entities.propertySetting.importer.hint'),
);
